import introJs from 'intro.js'
import 'intro.js/minified/introjs.min.css'

export default {
  //@ts-ignore
  install(app) {
    app.config.globalProperties.$intro = introJs
  }
}
